var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"btn btn-light",attrs:{"onclick":"document.getElementById('opcje2').style.display = 'flex'"}},[_vm._v(" Zmień tło ")])
}
var staticRenderFns = []

export { render, staticRenderFns }